import { render, staticRenderFns } from "./SenWordChatCommon.vue?vue&type=template&id=04a82846&"
import script from "./SenWordChatCommon.vue?vue&type=script&lang=js&"
export * from "./SenWordChatCommon.vue?vue&type=script&lang=js&"
import style0 from "./SenWordChatCommon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04a82846')) {
      api.createRecord('04a82846', component.options)
    } else {
      api.reload('04a82846', component.options)
    }
    module.hot.accept("./SenWordChatCommon.vue?vue&type=template&id=04a82846&", function () {
      api.rerender('04a82846', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/components/SenWordChatCommon.vue"
export default component.exports